import React, { memo } from 'react';
import classNames from 'classnames';
import { Container } from '@johnlewispartnership/wtr-ingredients/foundations/grid';
import BreadcrumbsWtr from '@johnlewispartnership/wtr-ingredients/ingredients/Breadcrumbs';
import { BreadcrumbLink } from '@johnlewispartnership/wtr-ingredients/ingredients/Breadcrumbs/BreadcrumbLink';
import { Typography } from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import { Link } from 'react-router-dom';
import { type Breadcrumbs as TBreadcrumbs, enrichBreadcrumbs } from 'utils/breadcrumbs';
import urls from 'constants/urls';

import styles from './index.scss';

export interface BreadcrumbsProps {
  baseUrl?: string;
  breadcrumbs?: TBreadcrumbs;
  currentPage?: string;
  white?: boolean;
  backgroundWhite?: boolean;
  className?: string;
}

const Breadcrumbs = ({
  breadcrumbs,
  baseUrl,
  currentPage,
  white = false,
  backgroundWhite = false,
  className,
}: BreadcrumbsProps) => {
  const enrichedBreadcrumbs = enrichBreadcrumbs({ baseUrl, breadcrumbs });

  return (
    <Container
      className={classNames(styles.container, {
        [styles.white]: white,
        [styles.hide]: enrichedBreadcrumbs.length < 2,
        [styles.backgroundWhite]: backgroundWhite,
      })}
    >
      <BreadcrumbsWtr className={className} light={white}>
        <BreadcrumbLink component={Link} to={urls.homepage}>
          Home
        </BreadcrumbLink>
        {enrichedBreadcrumbs.map(({ component = Link, name, path }) => {
          const breadcrumbLinkProps = component === 'a' ? { href: path } : { to: path };

          return (
            <BreadcrumbLink {...breadcrumbLinkProps} component={component} key={path} role="link">
              {name}
            </BreadcrumbLink>
          );
        })}
        {currentPage && (
          <Typography styleAs="paragraphSmall" className={styles.end}>
            {currentPage}
          </Typography>
        )}
      </BreadcrumbsWtr>
    </Container>
  );
};

Breadcrumbs.displayName = 'Breadcrumbs';

export default memo(Breadcrumbs);
